import { initStore } from './store';
import moment from 'moment-timezone';

const configStore = () => {
    const actions = {
        CLEAR_SELECTION: (curState) => {
            return {
                ...curState,
                selectedDay: null,
                selectedDate: null,
                selectedTime: null,
                selectedDateTime: null,
                eventDates: null
            };
        }
    };

    const configuration = {
        events: {},
        eventTitles: [],
        calendarType: null,
        monthChange: false,
        dateContext: moment().tz("Europe/London"),
        weekdaysShort: moment.weekdaysShort(),
        months: moment.months(),
        currentMonth: moment().tz("Europe/London").format("M"),
        currentDay: moment().tz("Europe/London").format("D"),
        currentYear: moment().tz("Europe/London").format("Y"),
        eventDates: null,
        selectedMonth: moment().tz("Europe/London").format("M"),
        selectedDay: null,
        selectedYear: moment().tz("Europe/London").format("Y"),
        selectedTime: null,
        selectedDate: null,
        selectedDateTime: null,
        thisMonth: null,
        modalIsOpen: true,
        submittingTime: false
    };

    // Log what's going to be initialized
    // console.log('Configuration for initStore:', configuration);

    // Call initStore with prepared actions and configuration
    initStore(actions, configuration);
};

export default configStore;